import { Add } from '@components/atoms/icons';
import { Button, ButtonProps } from '../../button';

interface AddButtonProps extends ButtonProps {
	onAdd: () => void;
	testId?: string;
	ariaLabel?: string;
}

export const AddButton = ({ onAdd, size, testId, ariaLabel, ...rest }: AddButtonProps) => {
	return (
		<Button
			variant="tertiaryNew"
			size={size}
			iconButton
			onClick={onAdd}
			data-testid={testId || 'add-button'}
			aria-label={ariaLabel || 'Add'}
			{...rest}
		>
			<Add />
		</Button>
	);
};
